/**
 * Toggle Display on click
 * @module styliticsToggle
 */

import $ from "jquery";
import registerJQueryPlugin from "styleguide/lib/register-jquery-plugin";
import mergeOptions from "styleguide/lib/merge-options";
import "styleguide/modules/slick-slider";
export const PLUGIN_NAME = "styliticsToggle";
export const CLICK_HANDLER = "click";
export const CHANGE_HANDLER = "change";
export const FOCUS_HANDLER = "focus";
export const BLUR_HANDLER = "blur";
export const DEFAULTS = {};

const initSlider = (toggleCarousel) => {
  $(toggleCarousel).slickSlider({
    slidesToShow: 3,
    slidesToScroll: 2,
    infinite: false,
  });
};

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const toggler = ($el, toggleShow, toggleHide, toggleAnimation, parentBlock, toggleCarousel) => {
  if (toggleAnimation === "pop") {
    if (parentBlock) {
      $el.closest(parentBlock).find(toggleShow).show();
      if (toggleCarousel) {
        initSlider(toggleCarousel);
      }
      $el.closest(parentBlock).find(toggleHide).hide();
    } else {
      $(toggleShow).show();
      $(toggleHide).hide();
    }
  } else {
    if (parentBlock) {
      $el.closest(parentBlock).find(toggleShow).slideDown();
      if (toggleCarousel) {
        initSlider(toggleCarousel);
      }
      $el.closest(parentBlock).find(toggleHide).slideUp();
    } else {
      $(toggleShow).slideDown();
      $(toggleHide).slideUp();
    }
  }
};

const setEventListeners = ($el, opts) => {
  const {
    toggleHide,
    toggleShow,
    toggleAnimation,
    parentBlock,
    toggleCarousel,
  } = opts;

  $el.on(CLICK_HANDLER, () => {
    toggler($el, toggleShow, toggleHide, toggleAnimation, parentBlock, toggleCarousel);
  });
  $el.on(FOCUS_HANDLER, () => {
    toggler($el, toggleShow, toggleHide, toggleAnimation, parentBlock, toggleCarousel);
  });
};

/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function styliticsToggle(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, styliticsToggle);



// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/stylitics-toggle.js